module.exports = __webpack_public_path__ + "static/media/arrow-back-coinera.19168334.svg";